import React, { Children, Component, Fragment, Suspense } from "react";
import { getImagesData } from "./getImagesData";
class FullscreenProvider extends Component {
  constructor(props) {
    super(props);
    this.onClose = () => this.setState({ isExpanded: false });
    this.addExpand = (config) => {
      const { isModalSuspended } = this.props;
      if (isModalSuspended) {
        return config;
      }
      const onExpand = (blockKey, innerIndex = 0) => {
        const { expandModeData, FullscreenModal } = this.state;
        if (!FullscreenModal && !this._FullscreenModal) {
          return false;
        }
        if (!FullscreenModal && this._FullscreenModal) {
          this.renderFullScreenModal();
        }
        this.setState({
          isExpanded: true,
          // if expandModeData is not defined - expand the first image
          index: expandModeData ? expandModeData.imageMap[blockKey] + innerIndex : 0
        });
      };
      const imageConfig = config["wix-draft-plugin-image"];
      const galleryConfig = config["wix-draft-plugin-gallery"];
      if (imageConfig && !imageConfig.onExpand) {
        config["wix-draft-plugin-image"] = { ...imageConfig, onExpand };
      }
      if (galleryConfig && !galleryConfig.onExpand) {
        config["wix-draft-plugin-gallery"] = { ...galleryConfig, onExpand };
      }
      return config;
    };
    this.onChildHover = () => {
      const { FullscreenModal } = this.state;
      if (!FullscreenModal && this._FullscreenModal) {
        this.renderFullScreenModal();
      }
    };
    this.state = {
      isExpanded: false,
      index: 0
    };
  }
  componentDidMount() {
    const { experiments, content } = this.props;
    if (content) {
      const imagesData = getImagesData(content);
      if (imagesData.images.length > 0) {
        this.setState({ expandModeData: imagesData });
        this.lazyLoadFullscreen();
        if (this.props.isMobile) {
          const timeout = parseInt(experiments?.optimizeFullScreenModal?.value || "0");
          this._renderFullscreenInterval = setTimeout(() => {
            this.renderFullScreenModal();
          }, timeout);
        }
      }
    }
  }
  renderFullScreenModal() {
    this.setState({ FullscreenModal: this._FullscreenModal });
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.content !== this.props.content) {
      if (nextProps.content) {
        const imagesData = getImagesData(nextProps.content);
        if (!this._FullscreenModal && imagesData.images.length > 0) {
          this.lazyLoadFullscreen();
        }
        this.setState({ expandModeData: imagesData });
      }
    }
  }
  componentWillUnmount() {
    clearTimeout(this._renderFullscreenInterval);
  }
  lazyLoadFullscreen() {
    const FullscreenModal = React.lazy(
      () => import(
        /* webpackChunkName: "ricos_FullscreenModalViewer"  */
        "./FullscreenModal"
      )
    );
    this._FullscreenModal = FullscreenModal;
  }
  render() {
    const { isExpanded, index, expandModeData, FullscreenModal } = this.state;
    const { children, isModalSuspended, isMobile, fullscreenProps } = this.props;
    const config = this.addExpand(children.props.config);
    return /* @__PURE__ */ React.createElement(Fragment, null, Children.only(React.cloneElement(children, { config, onHover: this.onChildHover })), FullscreenModal && /* @__PURE__ */ React.createElement(Suspense, { fallback: /* @__PURE__ */ React.createElement("div", null) }, /* @__PURE__ */ React.createElement(
      FullscreenModal,
      {
        dataHook: "RicosFullScreen",
        isOpen: isExpanded && !isModalSuspended,
        images: expandModeData?.images || [],
        onClose: this.onClose,
        index,
        isMobile,
        ...fullscreenProps
      }
    )));
  }
}
export {
  FullscreenProvider as default
};
//# sourceMappingURL=FullscreenProvider.js.map
